import Img from "../../assets/director.png";

const DirectorDesk = () => {
    return (
        <div id="director" className="about-message container">
            <div className="message-left">
                <img src={Img} alt="director" />
            </div>

            <div className="message-right">
                <h2>DIRECTOR'S DESK</h2>
                <p>
                    I am very pleased to welcome you to Nav Jeevan Mission School. In my role as Director, 
                    I will be your first point of contact at the school. Nav Jeevan Mission School accepts 
                    students from pre-kindergarten to Grade 12. We believe education transforms lives, and 
                    that transformed people can make a difference in their societies and in India. 
                    The first school in Kasia, Deoria, Anand Nagar, Tumkuhi, Nav Jeevan Mission School is 
                    the obvious choice for nurturing your child to succeed at the highest levels. For your 
                    peace of mind, I encourage you to ask as many questions as you like and take as much time 
                    as you need in order to evaluate our school. I am ready to assist you with any questions 
                    you may have about Nav Jeevan Mission School. All schools are different and each school 
                    has its own guiding principles. Ours are embodied in our mission statement and our two core 
                    fundamental guiding principles – fostering individual ability and providing holistic development 
                    to your child in a warm, caring and safe environment. We welcome your visit so please contact the 
                    admissions office for a personal appointment with me and a school tour with our admission liaison 
                    executive. I look forward to welcome you into our Nav Jeevan Mission School family in the very near future.
                </p>
                <h4>Mr. P. C. Samkutty</h4>
                <h4>- Director -</h4>
            </div>
        </div>

    );
};

export default DirectorDesk;